
import {useInstance} from 'react-ioc';
import {useNavigate} from 'react-router-dom';
import {Button} from 'antd';

import {INDEX} from '../../config/routes';
import {Store} from '../../model/store/Store';

import cls from './Result.module.scss'


export const Result = () => {

    const {auth} = useInstance(Store)
    const navigate = useNavigate();

    return (

        <div className={cls.page}>

            <h1>Результат: {auth.result}/7</h1>

            <div>Очень хорошо!<br/>
                В следующий раз удача будет на вашей стороне 🍀</div>

            <Button onClick={() => navigate(INDEX)}>Попробовать ещё раз</Button>

        </div>

    )
}


